export default "__VITE_ASSET__6cXPebzpyEfI166TiAsuBA__"